import { fetchSessionJson } from '../SessionRequest';
import { toRequiredPositiveInteger } from '../Utilities';
import type { ReportDefinition } from '../../types/ReportDefinition';

const API_SERVER = process.env.API_SERVER || '';

export async function getReports(
  subscriptionId: number | string | null | undefined,
  districtId: number | string | null | undefined
): Promise<ReportDefinition[]> {
  const validatedSubscriptionId = toRequiredPositiveInteger(subscriptionId, 'subscriptionId');
  const validatedDistrictId = toRequiredPositiveInteger(districtId, 'districtId');

  return fetchSessionJson<ReportDefinition[]>(
    `${API_SERVER}/subscriptions/admin/subscriptions/${validatedSubscriptionId}/districts/${validatedDistrictId}/reports`,
    'Failed to fetch district reports'
  );
}

const DistrictReportService = { getReports };

export default DistrictReportService;
